import React, { useState } from 'react';
import { NewsArticle } from '../../data/news';
import { Card, CardHeader, CardTitle, CardContent } from '../../components/ui/card';
import { Separator } from '../../components/ui/separator';
import Newsletter from '../Common/Newsletter/Newsletter';
import Footer from '../Common/Footer/Footer';
import HeaderImage from '../../assets/images/itmonkeys-cyber-img-5.png';
import Navbar from '../Common/Navbar/Navbar';
import { Link } from 'react-router-dom';
import useSectionRefs from '../../hooks/useSectionRefs';
import { newsArticles } from '../../data/news';
interface TemplateProps {
  category: string;
  title: string;
  description: string;
}

const CyberNewsListTemplate: React.FC<TemplateProps> = ({ category, title, description }) => {
  const sectionRefs = useSectionRefs();  
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const handleOpenContactModal = () => {
    setIsContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setIsContactModalOpen(false);
  };
  const filteredArticles = newsArticles.filter(article => article.category === category);

  return (
    <div>
      <section className="tw-min-h-[70vh] tw-flex tw-items-center tw-relative" ref={sectionRefs.header}>

        <div className="tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-blue-950/100 tw-to-stone-900/100 tw-z-0"></div>
        
        <div className="tw-container tw-pt-20 tw-pb-10 tw-mx-auto tw-flex tw-flex-row tw-items-center tw-gap-12 tw-px-4 tw-relative tw-z-10">
          <div className="tw-w-2/5 tw-space-y-6">
            <h1 className="tw-category-title tw-font-bold">{title}</h1>
            <p className="tw-text-xl tw-text-gray-300">{description}</p>
          </div>

          <div className="tw-w-3/5">
            <div className="tw-relative tw-h-96 tw-rounded-2xl tw-overflow-hidden tw-shadow-xl">
              <img src={HeaderImage} alt={title} className="tw-w-full tw-h-full tw-object-cover tw-absolute tw-inset-0" />
            </div>
          </div>
        </div>
      </section>

      <div className="tw-container tw-mx-auto tw-px-4 tw-py-12">
        <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-8">
          <div className="tw-flex-1">
            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-2 tw-gap-6">
              {filteredArticles.map(article => (
                <Card key={article.id} className="hover:tw-shadow-lg tw-transition-shadow">
                  <CardHeader>
                    <CardTitle className="tw-text-xl">{article.title}</CardTitle>
                  </CardHeader>
                  <div className="tw-px-6 tw-pb-4">
                    <img src={article.image} alt={article.title} className="tw-w-full tw-h-48 tw-object-cover tw-rounded-lg tw-mb-4" />
                  </div>
                  <CardContent>
                    <p className="tw-text-muted-foreground tw-line-clamp-3 tw-mb-4">{article.summary}</p>
                    <Link 
                      to={`/cyber-news/${article.category}/${article.slug}`}
                      className="tw-text-primary tw-font-medium hover:tw-underline"
                    >
                      Lire la suite →
                    </Link>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>

          <div className="tw-hidden md:tw-block tw-w-full md:tw-w-80 tw-space-y-8">
            <Card>
              <CardHeader>
                <CardTitle className="tw-text-lg">Articles les plus lus</CardTitle>
              </CardHeader>
              <CardContent className="tw-space-y-4">
                {newsArticles.slice(0, 4).map((article) => (
                  <div key={article.id}>
                    <Link 
                      to={`/cyber-news/${article.category}/${article.slug}`}
                      className="tw-text-sm tw-font-medium hover:tw-underline tw-flex tw-items-center tw-gap-[0.45rem]"
                    >
                      <img
                        src={article.image}
                        alt={article.title}
                        className="tw-w-12 tw-h-12 tw-object-cover tw-rounded"
                      />
                      {article.title}
                    </Link>
                    <Separator className="tw-my-3" />
                  </div>
                ))}
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="tw-text-lg">Dernières mises à jour</CardTitle>
              </CardHeader>
              <CardContent className="tw-space-y-4">
                {newsArticles.slice(0, 3).map((article) => (
                  <div key={article.id} className="tw-flex tw-gap-4">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="tw-w-20 tw-h-20 tw-object-cover tw-rounded"
                    />
                    <div>
                      <Link 
                        to={`/cyber-news/${article.category}/${article.slug}`}
                        className="tw-text-sm tw-font-medium hover:tw-underline tw-line-clamp-2"
                      >
                        {article.title}
                      </Link>
                      <p className="tw-text-xs tw-text-muted-foreground tw-mt-1">
                        {new Date(article.date).toLocaleDateString()}
                      </p>
                    </div>
                  </div>
                ))}
              </CardContent>
            </Card>
          </div>
        </div>
      </div>

      <section id="newsletter" className="section dark" ref={sectionRefs.newsletter}>
        <Newsletter />
        <Footer />
      </section>
    </div>
  );
};

export default CyberNewsListTemplate; 